import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=a0d0d29c&scoped=true&"
import script from "./notification.vue?vue&type=script&lang=js&"
export * from "./notification.vue?vue&type=script&lang=js&"
import style0 from "./notification.vue?vue&type=style&index=0&id=a0d0d29c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d0d29c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0d0d29c')) {
      api.createRecord('a0d0d29c', component.options)
    } else {
      api.reload('a0d0d29c', component.options)
    }
    module.hot.accept("./notification.vue?vue&type=template&id=a0d0d29c&scoped=true&", function () {
      api.rerender('a0d0d29c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/shared/core/notification.vue"
export default component.exports